<template>
    <div ref="recaptcha"/>
</template>

<script>
/* TODO
 * I don't love this implementation. There were a lot of hoops to jump through in order to get this working.
 *
 * When you tie the recaptcha challenge to the submit button, it disrupts the @submit event trigger for VeeValidate Form. Couldn't figure out why.
 * But if you don't tie the challenge to the submit button, you have to manage recaptcha execution manually, and grecaptcha.execute() does not properly support promises.
 * We opted for the latter strategy and have documented lapses of best practice where possible.
 *
 */
export default {

    name: 'InvisibleRecaptcha',
    data() {
        return {
            recaptcha: null
        }
    },
    emits: {
        verified: (response) => {
            return !!response; // returns a bool with the "truthiness" value of the response.
        },
        expired: null,
        failed: null
    },
    methods: {
        renderRecaptcha() {
            //Anchor the recaptcha challenge to the element in the default slot, if present. Otherwise use the template root.
            let recaptchaElement = this.$refs.recaptcha;

            this.recaptcha = window.grecaptcha.render(recaptchaElement, {
                'sitekey': process.env.VUE_APP_RECAPTCHA_SITE_KEY,
                'size': 'invisible',
                'callback': (response) => this.$emit('verified', response),
                'expired-callback': () => this.reset,
                'error-callback': () => this.$emit('failed')
            });
        },
        reset() {
            this.$emit('expired');
            window.grecaptcha.reset(this.recaptcha);
        },
        execute() {
            window.grecaptcha.execute();
        }
    },
    mounted() {
        //Check to see if recaptcha has been loaded elsewhere.
        if (window.grecaptcha == null) {
            new Promise((resolve) => {

                //Define a callback function that will be resolved after the recaptcha script is present.
                window.recaptchaReady = function () {
                    resolve();
                };

                //Dynamically create a script tag and load the recaptcha script
                const scriptTag = window.document.createElement('script');
                scriptTag.id = 'recaptcha-script';
                scriptTag.setAttribute('async', '');
                scriptTag.setAttribute('defer', '');
                scriptTag.setAttribute('src', `https://www.google.com/recaptcha/api.js?onload=recaptchaReady&render=explicit&hl=${this.$i18n.locale}`); //TODO hardcoded url
                window.document.head.appendChild(scriptTag);
            }).then(() => {
                //After this promise resolves, we should have a grecaptcha object, so render.
                this.renderRecaptcha();
            });
        } else {
            //Recaptcha has been loaded elsewhere, so simply render the recaptcha.
            this.renderRecaptcha();
        }
    },

};
</script>